@if (visible()) {
  <aside
    class="primer"
    role="complementary"
    [attr.aria-label]="'shell.push_primer.aria_label' | transloco"
    data-testid="push-primer">

    <button
      type="button"
      class="primer__close"
      [attr.aria-label]="'shell.push_primer.close' | transloco"
      data-testid="push-primer-close"
      (click)="onClose()">
      <paper-icon name="close" [size]="16" />
    </button>

    <div class="primer__chip" aria-hidden="true">
      <paper-icon name="bell" [size]="20" />
    </div>

    <h2 class="primer__title">{{ 'shell.push_primer.title' | transloco }}</h2>
    <p class="primer__body">{{ 'shell.push_primer.body' | transloco }}</p>

    <!-- Polite live region — announces phase changes without stealing focus. -->
    <p class="primer__status" aria-live="polite">
      @if (phase() === 'success') {
        <span class="primer__status-line primer__status-line--ok">
          <paper-icon name="check" [size]="16" />
          {{ 'shell.push_primer.success' | transloco }}
        </span>
      } @else if (blocked()) {
        <span class="primer__status-line primer__status-line--err">
          {{ 'shell.push_primer.blocked' | transloco }}
        </span>
      } @else if (phase() === 'error' && serviceError()) {
        <span class="primer__status-line primer__status-line--err">
          {{ ('shell.push_primer.errors.' + serviceError()) | transloco }}
        </span>
      }
    </p>

    @if (phase() !== 'success') {
      <div class="primer__actions">
        @if (!blocked()) {
          <paper-button
            intent="primary"
            size="sm"
            [loading]="phase() === 'pending'"
            data-testid="push-primer-enable"
            (click)="onEnable()">
            {{ 'shell.push_primer.enable' | transloco }}
          </paper-button>
        }
        <paper-button
          intent="ghost"
          size="sm"
          data-testid="push-primer-not-now"
          (click)="onNotNow()">
          {{ 'shell.push_primer.not_now' | transloco }}
        </paper-button>
      </div>
    }
  </aside>
}
